export default __webpack_public_path__ + "2b0506cfd1d78e56bb072c3d80d69617.png";